import axios from "axios";
import { CSVLink } from "react-csv";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import { Autocomplete, Box, FormControl, Icon, IconButton, InputLabel, LinearProgress, MenuItem, Select, TextField } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import InputMask from "react-input-mask";

import { URL_API } from "config";
import MDInput from "components/MDInput";
import { useAuthContext } from "context/AuthContext";
import moment from "moment";

const useStyles = makeStyles((_) => ({
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
      padding: "3px",
      width: 148,
    },
  },
}));

function AnaliticTable() {
  const [cooperateds, setCooperateds] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [analitics, setAnalitics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState();
  const [companyGuid, setCompanyGuid] = useState();
  const [status, setStatus] = useState(0);
  const [dateFrom, setDateFrom] = useState(moment().subtract(1, 'month').format('YYYY-MM-DD'));
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));

  const classes = useStyles();

  const navigate = useNavigate();

  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  var dataTableData = {
    columns: [
      { Header: "Criação", accessor: "createdAt" },
      { Header: "Atualização", accessor: "updatedAt" },
      { Header: "Nome", accessor: "full_name" },
      { Header: "Número Conta", accessor: "account_number" },
      { Header: "Companhia", accessor: "company_name" },
      { Header: "CPF", accessor: "cpf" },
      { Header: "Telefone", accessor: "phone" },
      { Header: "Email", accessor: "email" },
      { Header: "StatusCooperated", accessor: "status" },
    ],
    rows: cooperateds,
  };

  const stts = [
    { name: "Todos", id: 0 },
    { name: "Em Aberto", id: 1 },
    { name: "Iniciado", id: 2 },
    { name: "Em Análise", id: 3 },
    { name: "Pendência Documentos", id: 4 },
    { name: "Em Processo de Admissão", id: 5 },
    { name: "Aprovado", id: 6 },
    { name: "Reprovado", id: 7 },
    { name: "Aguardando Assinatura", id: 8 },
    { name: "Finalização Cadastral", id: 10 },
  ];

  useEffect(() => {
    (async () => {
      setLoading(true);

      await getCompanies();

      if (user?.company_id) setCompanyGuid(user?.company_id)

      await getAnalitics();

      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getCompanies() {
    await axios.get(URL_API + "/companies?page=1&limit=500", {
      headers: {
        Authorization: `Bearer ${tag}`,
      },
    }).then(function (response) {
      setCompanies(response.data.data);
    }).catch(function (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Tag");
        navigate("/auth/login");
      }
      toast.error(error?.response?.data?.message);
    });
  }

  async function getAnalitics() {
    await axios.get(
      URL_API +
      `/analitics?dateFrom=${dateFrom}&dateTo=${dateTo}` +
      `${filter ? `&filter=${filter}` : ""}` +
      `${status ? `&status=${status}`  : ""}` +
      `${companyGuid ? `&company_id=${companyGuid}` : ""}`,
      {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      }
    ).then(function (response) {
      for (const coop of response.data.cooperateds) {
        const obj = companies.find((o) => o.uuid === coop.company_id);

        if (obj) coop.company_name = obj?.name;

        Object.assign(coop, {
          createdAt: new Date(coop.created_at).toLocaleDateString('pt-BR'),
          updatedAt: new Date(coop.updated_at).toLocaleDateString('pt-BR'),
        })
      }

      setCooperateds(response.data.cooperateds);
      setAnalitics(response.data.analitics);
    }).catch(function (error) {
      if (error?.response?.status === 500 && error?.response?.data?.code === "22P02") {
        toast.info("Lista vazia")

        return;
      }

      if (error?.response?.status === 401) {
        localStorage.removeItem("Tag");
        navigate("/auth/login");
      } else {
        toast.error(error?.response?.data?.message);
      }
    });
  }

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox pt={2}>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Filtros para Colaboradores
                </MDTypography>
              </MDBox>
              <MDBox
                p={1}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid container>
                  {user?.profile === 99 && (
                    <>
                      <Autocomplete
                        className="textfield"
                        classes={classes}
                        sx={{ marginBottom: 1 }}
                        onChange={(_, value) => setCompanyGuid(value.uuid)}
                        getOptionLabel={(company) => company.name}
                        options={companies}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Buscar por companhias..."
                          />
                        )}
                      />
                      <MDBox p={1} />
                    </>
                  )}
                  <Grid item>
                    <MDInput
                      label="Buscar por colaborador..."
                      onChange={async (event) => setFilter(event.target.value)}
                      size="large"
                    />
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <FormControl sx={{ width: 190 }}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={status}
                        label="Status"
                        sx={{ height: '45px' }}
                        onChange={(value) => setStatus(value.target.value)}
                      >
                        {
                          stts.map((s) => {
                            return (
                              <MenuItem value={s.id}>{s.name}</MenuItem>
                            )
                          })
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <InputMask
                      aria-describedby="inputGroup-sizing-lg"
                      aria-label="Sizing example input"
                      type="text"
                      mask="99/99/9999"
                      name="dateFrom"
                      defaultValue={moment(dateFrom).format('DD/MM/YYYY')}
                      onChange={(event) => {
                        if (event.target.value.indexOf("_") === -1) {
                          setDateFrom(event.target.value.split('/').reverse().join('-'))
                        }
                      }}
                    >
                      {() => <TextField label="Buscar por data inicial..." />}
                    </InputMask>
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <InputMask
                      aria-describedby="inputGroup-sizing-lg"
                      aria-label="Sizing example input"
                      type="text"
                      mask="99/99/9999"
                      name="dateTo"
                      defaultValue={moment(dateTo).format('DD/MM/YYYY')}
                      onChange={(event) => {
                        if (event.target.value.indexOf("_") === -1) {
                          setDateTo(event.target.value.split('/').reverse().join('-'))
                        }
                      }}
                    >
                      {() => <TextField label="Buscar por data final..." />}
                    </InputMask>
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <IconButton
                      onClick={async () => await getAnalitics()}
                      sx={{
                        color: '#fff',
                        background: '#3f50b5',
                        borderRadius: '8px',
                        "&:hover": {
                          backgroundColor: "blue",
                        },
                      }}
                    >
                      <Icon>search</Icon>
                    </IconButton>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </Card>
          <MDBox pt={2}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Colaboradores
                </MDTypography>
                {cooperateds.length > 0 && (
                  <div style={{ display: "flex" }}>
                    <CSVLink filename="CooperatedTable.csv" data={analitics}>
                      <MDButton color="light">BAIXAR TABELA CSV</MDButton>
                    </CSVLink>
                    <div style={{ width: "10px" }} />
                    <CSVLink
                      filename="CooperatedTable.xls"
                      data={analitics}
                      separator=";"
                      enclosingCharacter=""
                    >
                      <MDButton color="light">BAIXAR TABELA XLS</MDButton>
                    </CSVLink>
                  </div>
                )}
              </MDBox>
              {
                loading ?
                  <Box sx={{ width: '100%' }}>
                    <LinearProgress sx={{ overflow: 'hidden' }} />
                  </Box> :
                  <DataTable table={dataTableData} />
              }
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}

export default AnaliticTable;
